import { useMemo } from 'react'
import InsightViewOption, { InsightViewOptionStrings } from 'enums/InsightViewOption'
import { useApplicationSettings } from 'hooks/usePageConfig'
import {
  generateIncludedEmojisStrategy,
  generateIncludedTermsStrategy,
  generateSentimentsWithTermsStrategy
} from 'utils/insightModal/strategy/widgetSettingComposing'

const useWidgetSettingComposingStrategy = (viewOption: InsightViewOptionStrings) => {
  const applicationSettings = useApplicationSettings()
  const widgetSettingComposingStrategy = useMemo(() => {
    switch (viewOption) {
      case InsightViewOption.BRANDS:
      case InsightViewOption.HASHTAGS:
      case InsightViewOption.PEOPLE:
      case InsightViewOption.TERMS:
        return generateIncludedTermsStrategy(applicationSettings)
      case InsightViewOption.EMOJIS_GROUP:
      case InsightViewOption.EMOJIS_EMOTION:
      case InsightViewOption.EMOJIS_EMOJI:
        return generateIncludedEmojisStrategy()
      case InsightViewOption.THINGS:
        return generateSentimentsWithTermsStrategy(applicationSettings)
      default:
        throw new Error(`Unsupported view option: ${viewOption}`)
    }
  }, [viewOption, applicationSettings])

  return widgetSettingComposingStrategy
}

export default useWidgetSettingComposingStrategy
